import { useLocation, useNavigate } from 'react-router-dom';

import { PaymentWizard } from '@/components/payments/wizard/PaymentWizard';
import type { DepositNavigationState } from '@/types/payment';

export const PaymentFlow: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // When launched as a "Depositar" deposit, the beneficiary is prefilled and the
  // wizard starts at the fund-source step. Absent (e.g. a direct visit or a hard
  // refresh), the wizard starts normally at type-selection.
  const initialBeneficiary = (location.state as DepositNavigationState | null)
    ?.depositBeneficiary;

  const handleClose = () => {
    // Navigate back to the appropriate dashboard based on user role
    void navigate(-1); // Go back to previous page
  };

  return <PaymentWizard onClose={handleClose} initialBeneficiary={initialBeneficiary} />;
};
